import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ClientOpportunitySummary } from '@features/contacts/models/opportunity';
import { ClientService } from '@features/contacts/services/client.service';
import { displayOpportunityType } from '@shared/models/opportunity';
import { ContactEventService, ContactInfo } from '@features/contacts/services/contact-event.service';

@Component({
  selector: 'spark-contact-opportunity-list',
  templateUrl: './contact-opportunity-list.component.html',
  styleUrls: ['./contact-opportunity-list.component.scss']
})
export class ClientOpportunityListComponent {
  private contact$: Observable<ContactInfo> = this.contactEventService.selectedContactInfo$;
  opportunities$: Observable<ClientOpportunitySummary[]> = this.contact$.pipe(
    switchMap((contact) => this.companyService.getOpportunities(contact.id))
  );

  displayOpportunityType = displayOpportunityType;

  constructor(
    private contactEventService: ContactEventService,
    private companyService: ClientService,
    public router: Router
  ) {}
}
